export const email = (value) => {
	if (!/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i.test(value)) {
		return 'Please enter valid email address';
	}
};
